module.exports = __webpack_public_path__ + "static/image3-0d9578433caf3de00b5bcdf810764eb1.png";